<div class="months">
  <div class="month" *ngFor="let month of months" [class.current]="current === month.index" (click)="change.emit(month.index)">
    <div class="month-name">{{ month.first.format('MMM').replace('.', '') }}</div>
    <div class="month-grid">
      <div *ngFor="let day of month.days" [class]="dayClass(day)"></div>
    </div>
  </div>
</div>
